import React, { useMemo } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const PROGRESS_BAR_SIZE = {
  normal: 'normal',
  large: 'large',
};

const PROGRESS_BAR_SIZE_VALUE = {
  normal: '8px',
  large: '20px',
};

const TransientProps = ['color'];

const StyledProgressBar = styled(Flex, {
  shouldForwardProp: (prop) => !TransientProps.includes(prop),
})(() => ({
  borderRadius: '4px',
  background: '#EAEAEA',
  width: '100%',
  overflow: 'hidden',
  position: 'relative',
}));

/**
 * data should be an array of following shape.
 * [{ color: 'red', weight: 20 }]
 *
 * default totalWeight is 100, if for some reason passed weight total is more than 100,
 * that total will be considered as totalWeight.
 * */

const SplitProgressBar = ({
  data = [],
  totalWeight = 100,
  size = PROGRESS_BAR_SIZE.normal,
  showPercentage = false,
  percentageValue,
}) => {
  let height;
  switch (size) {
    case PROGRESS_BAR_SIZE.normal:
      height = PROGRESS_BAR_SIZE_VALUE.normal;
      break;
    case PROGRESS_BAR_SIZE.large:
      height = PROGRESS_BAR_SIZE_VALUE.large;
      break;
    default:
      console.error(`Error: Invalid size : ${size} . Pick one from [${Object.keys(PROGRESS_BAR_SIZE)}]`);
      height = PROGRESS_BAR_SIZE_VALUE.normal;
      break;
  }

  const [fixedData, fixedTotalWeight] = useMemo(() => {
    const sumOfWeights = data.reduce((sum, curr) => sum + curr.weight, 0);

    if (sumOfWeights <= totalWeight) {
      return [
        [
          ...data,
          {
            color: '#EAEAEA',
            weight: totalWeight - sumOfWeights,
          },
        ],
        totalWeight,
      ];
    }
    return [data, sumOfWeights];
  }, [data, totalWeight]);

  return (
    <Flex>
      <Box flexGrow={1}>
        <StyledProgressBar height={height}>
          {fixedData.map(({ color, weight }, index) => (
            <Box key={index} minWidth={`${(weight * 100) / fixedTotalWeight}%`} height={height} bgColor={color} />
          ))}
        </StyledProgressBar>
      </Box>

      {showPercentage && (
        <TextBodyMedium sx={{ marginLeft: '4px', minWidth: '5ch' }} bold>
          {percentageValue}%
        </TextBodyMedium>
      )}
    </Flex>
  );
};

export { SplitProgressBar };
